import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,{staticClass:"dot-leader px-10",attrs:{"cols":"12"}},[_c('b',[_vm._v(_vm._s(_vm.itemTitle))]),_c('div',{staticClass:"dot-leader__dots"}),_c('label',[_vm._t("content")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }